module.exports = __webpack_public_path__ + "static/media/no-unlocked-stories.db7d9f45.png";